import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { resetPassword } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import { Link } from 'react-router-dom';
import './Login.css';
import './_Buttons.css';
import './_Input.css';

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        try {
            await resetPassword(token, password, confirmPassword);
            setMessage('Password has been reset successfully.');
            setError('');
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (error) {
            setError(mapErrorMessage(error.message));
            setMessage('');
        }
    };

    return (
        <div>
        <div className="lp-topbar">
            <Link to="/" className="lp-logo lp-logo-pointer"><div className="lp-logo"><img src="/logo.png" alt="aistCRM" className="logo-img" /></div></Link>
        </div>
        <div className="login-container">
            <form onSubmit={handleResetPassword} className="login-form">
                {message && <p className="message">{message}</p>}
                {error && <p className="error">{error}</p>}
                <input
                    type="password"
                    placeholder="New Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Confirm New Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                />
                <button type="submit">Reset Password</button>
            </form>
        </div>
        </div>
    );
};

export default ResetPassword;
